import hyperform from "hyperform"
import maskInput from "vanilla-text-mask"
import Choices from "choices.js"
import pose from "popmotion-pose"

import { q, qq } from "../../helper/q"

export const authInit = () => {
  const authForm = q(".authForm")
  if (authForm) {
    const poseAuthForm = {
      initialPose: "close",
      open: {
        opacity: 1,
        y: 0
      },
      close: {
        opacity: 0,
        y: 50
      }
    }
    const authFormElement = q(".authForm")
    const forgetFormElement = q(".forgetPasswordForm")

    const authPoser = pose(authFormElement, poseAuthForm)
    const forgetPoser = pose(forgetFormElement, poseAuthForm)
    authPoser.set("open")

    q(".js-forget", authFormElement).addEventListener("click", e => {
      e.preventDefault()
      authPoser.set("close").then(done => {
        authFormElement.classList.add("authFormHidden")
        forgetPoser.set("open")
        forgetFormElement.classList.remove("forgetPasswordFormHidden")
        return done
      })
    })

    q(".js-login", forgetFormElement).addEventListener("click", e => {
      e.preventDefault()
      forgetPoser.set("close").then(done => {
        forgetFormElement.classList.add("forgetPasswordFormHidden")
        authPoser.set("open")
        authFormElement.classList.remove("authFormHidden")
        return done
      })
    })

    const select = q(".choiseSelect")

    if (select) {
      const choices = new Choices(select, {
        searchEnabled: false
      })

      // select.addEventListener("change", e => {
      //   if (e.detail.value === "15") {
      //     q('input[name="UF_COME_FROM_TEXT"]').parentNode.classList.remove("floatInputWrapperHidden")
      //   } else {
      //     q('input[name="UF_COME_FROM_TEXT"]').parentNode.classList.add("floatInputWrapperHidden")
      //   }
      // })
    }

    qq(".autorizationContainer form").map(form => {
      if (form.querySelector("input[type='tel']")) {
        hyperform.addValidator(form.querySelector("input[type='tel']"), element => {
          const re = /^(\+7|7|8)?[\s/\\-]?\(?[0-9]{3}\)?[\s/\\-]?[0-9]{3}[\s/\\-]?[0-9]{2}[\s/\\-]?[0-9]{2}$/gm
          const valid = re.test(element.value)
          element.setCustomValidity(
            valid ? "" : element.value ? element.dataset.typeMismatch : element.dataset.valueMissing
          )
          return valid
        })
        maskInput({
          inputElement: form.querySelector('input[type="tel"]'),
          mask: ["+", /[1-9]/, " ", "(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
          showMask: false,
          keepCharPositions: false
        })
      }

      hyperform.setRenderer("attachWarning", function(warning, element) {
        element.parentNode.classList.add("floatInputError")
        element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
      })
      hyperform(form)
    })
  }
}
